<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('nova-categoria') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="voltar"
                >
                    {{ $t("voltar") }}
                </button>
                <button class="save-btn" type="button" @click="saveCategoria">
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="form-columns-fit mt-5">
            <div class="columns is-flex-wrap">
                <div class="column is-12">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input 
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="categoria.idcategoriaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!categoria.idcategoriaerp"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(2)"
                                ref="descricaoInput"
                                v-model="categoria.descricao"
                                placeholder="descricao-categoria-placeholder"
                                :maxlength="50"
                                :title="'descricao'"
                                :required="true"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!categoria.descricao"
                                uppercase
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(3)"
                                ref="categoriaSelect"
                                :title="'categoriapai'"
                                :options="categorias"
                                v-model="categoria.idcategoriapai"
                                :search="loadCategoria"
                                :getOptionLabel="getLabel"
                                :placeholder="'selecione'"
                                tooltipLabel="info-categoria-pai"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CategoriaService from "@/services/CategoriaService";
import CategoriaValidation from "@/services/validations/CategoriaValidation";
import Message from "@/models/Message";

export default {
    data() {
        return {
            canSelectCategoria: false,
            isLoading: false,
            categorias: [],
            categoria: {
                id: null,
                descricao: null,
                situacao: 1,
                idcategoriapai: null,
            },
            service: new CategoriaService(this.$http, this.$router),
            msgs: [],
            isSaving: false,
            validation: null,
        };
    },
    created() {
        this.service = new CategoriaService(this.$http, this.$router);
        this.validation = new CategoriaValidation(this.msgs);
        this.loadCategoria();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name+'-'+numberId;
        },
        voltar() {
            this.$emit("voltar")
        },
        loadCategoria(value = ".*") {
            // no caso é passado 0, por que na sql esta situacao <> :SITUACAO, nesse caso se quiser buscar todas passar 2.
            this.service
                .findAllCombo(0, value ? value : "")
                .then(this.mapItems)
                .then(allCategoria => {
                    this.categorias = allCategoria;
                    this.categorias.unshift({id: 0, label: this.$t('nenhuma-associacao-generica').toUpperCase()});
                }, 350)
                .finally(() => {
                    this.categorias.length > 0 ? this.categoria.idcategoriapai = this.categorias[0] : null
                });
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        saveCategoria() {
            if (this.validation.validate(this.categoria, this.$refs)) {
                this.isSaving = true;
                this.service.save(this.mapOnSave(this.categoria))
                    .then(body => {
                        if (body.content) {
                        let msg =
                            this.$t("msg-save-sucesso-n", { n: this.$t("categoria") }
                            );
                            this.msgs.push(new Message("success", msg, true, false));

                            this.categoria.id = body.content.id;

                            let objEmit = {
                                'origem': 'categoria',
                                'obj': { id: this.categoria.id, label: this.categoria.descricao } 
                            };

                            setTimeout(() => {
                                this.$emit('sucesso', objEmit);
                            }, 1000);
                        } else {
                            this.isSaving = false;
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: this.categoria.idcategoriaerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    });
            }
        },
        mapOnSave (categoria) {
            return {
                idcategoriaerp: categoria.idcategoriaerp,
                idcategoria: categoria.idcategoria,
                descricao: categoria.descricao,
                situacao: categoria.situacao,
                idcategoriapai: categoria.idcategoriapai.id
            }
        },
        mapItems(body) {
            return body.content ? body.content.map(m => {
                return {                    
                    id: m.idcategoria,
                    label: m.idcategoria+" - "+m.descricao,
                }
            }) : [];
        },
    }
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    background-color: $sovis-white;
}
</style>